import { lazy, Suspense } from 'react';
import { Tagged } from '~/apps/smartsend/components/Tagged';
import { RoutingConstants } from '~/apps/smartsend/lib/consts/RoutingConstants';
import { NavigationContext } from '~/components/nav/nav-context';
import useOnLoad from '../use-on-load';
import { useContext } from 'react';
import useSmartSendAnalytics from '~/hooks/use-smartsend-analytics';
import { GenerateBaseAnalyticsPayload } from '~/lib/utils/analytics';

const MyProductsPage = lazy(() => import('~/apps/smartsend/components/my-products/MyProductsPage'));

export default function Component() {
  const { dispatch: navigationDispatch } = useContext(NavigationContext);
  const { track } = useSmartSendAnalytics();

  useOnLoad(() => {
    const title = 'My Products';
    document.title = title;
    navigationDispatch({
      type: 'INITIALISE_NAVIGATION',
      payload: { title, currentPageRoute: RoutingConstants.MyProducts }
    });
    track({
      type: 'page_view',
      payload: {
        ...GenerateBaseAnalyticsPayload([]),
        page: RoutingConstants.MyProducts
      }
    });
  });

  return (
    <Tagged tag="screen-my-products">
      <Suspense>
        <MyProductsPage />
      </Suspense>
    </Tagged>
  );
}
